import { render, staticRenderFns } from "./UnidadCompuesta.vue?vue&type=template&id=633ade20&scoped=true"
import script from "./UnidadCompuesta.vue?vue&type=script&lang=js"
export * from "./UnidadCompuesta.vue?vue&type=script&lang=js"
import style0 from "./UnidadCompuesta.vue?vue&type=style&index=0&id=633ade20&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633ade20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('633ade20')) {
      api.createRecord('633ade20', component.options)
    } else {
      api.reload('633ade20', component.options)
    }
    module.hot.accept("./UnidadCompuesta.vue?vue&type=template&id=633ade20&scoped=true", function () {
      api.rerender('633ade20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/unidad-compuesta/UnidadCompuesta.vue"
export default component.exports